import camelCase from "@/helpers/filters/camel_case";

/**
 * Generates a mixin for two-way binding with a prop and event.
 *
 * @param {string} key - The name of the prop to bind.
 * @param {string} eventName - The name of the event to emit for updates.
 * @example
 * export default {
 *   mixins: [toggleValue("dark")],
 *   computed: {
 *     activeTheme() {
 *       return this.isDark ? 'dark' : 'light'
 *     }
 *   },
 *   methods: {
 *     alternate() {
 *       this.toggleDark()
 *     }
 *   },
 * };
 *
 * @returns {import('vue').ComponentOptions<Vue>} A Vue mixin object.
 */
export function toggleValue(
  key,
  options = { initialValue: false, trueValue: true, falseValue: false }
) {
  const modelName = camelCase(`is ${key}`);
  const toggleName = camelCase(`toggle ${key}`);
  const onName = camelCase(`on ${key}`);
  const offName = camelCase(`off ${key}`);

  return {
    data: () => ({
      [modelName]: options.initialValue,
    }),
    methods: {
      [toggleName]() {
        if (this[modelName] === options.trueValue) {
          this[modelName] = options.falseValue;
          return;
        }

        if (this[modelName] === options.falseValue) {
          this[modelName] = options.trueValue;
        }
      },
      [onName]() {
        this[modelName] = options.trueValue;
      },
      [offName]() {
        this[modelName] = options.falseValue;
      },
    },
  };
}
